
const ServerInfo = (props) => {
    return (
        <div>
            <h3>Server Info</h3>
            <div className='grey-box'>
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>Machine Name:</strong>
                        {props.ServerInfo.MachineName}
                    </div>
                </div>
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>Machine IP:</strong>
                        {props.ServerInfo.LOCAL_ADDR}
                    </div>
                </div>
                {props.ServerInfo.RedundantServerIPHosts && props.ServerInfo.RedundantServerIPHosts.length > 0 &&
                    <div className='cf'>
                        <div className='column12'>
                            <strong className='server-info-heading'>Redundant Servers:</strong>
                            <ul>
                                {props.ServerInfo.RedundantServerIPHosts.map((host, index) =>
                                    <li key={index}>
                                        <a href={'http://' + host.IP + '/'}>{host.MachineName} - {host.Host} - {host.IP}</a>
                                    </li>)}
                            </ul>
                        </div>
                    </div>}
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>Remote Host:</strong>
                        {props.ServerInfo.REMOTE_HOST}
                    </div>
                </div>
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>Server Name:</strong>
                        {props.ServerInfo.SERVER_NAME}
                    </div>
                </div>
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>Remote Address:</strong>
                        {props.ServerInfo.REMOTE_ADDR}
                    </div>
                </div>
                <div className='cf'>
                    <div className='column12'>
                        <strong className='server-info-heading'>HTTP X Forwarded For:</strong>
                        {props.ServerInfo.HTTP_X_FORWARDED_FOR}
                    </div>
                </div>
                <div className='cf'>
                    <div className='column12 http-cookie'>
                        <strong className='server-info-heading'>HTTP Cookie:</strong>
                        <p>{props.ServerInfo.HTTP_COOKIE}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServerInfo;